// Chakra imports
import {
  Box,
  Button,
  Flex,
  useColorMode,
  useColorModeValue,
  Text,
  Spinner,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import PieChart from "components/charts/PieChart";
import Menu from "components/menu/MainMenu";
// Assets
import { pieChartOptions } from "variables/charts";
import { useState } from "react";
import { TefsModal } from "./TefsModal";
import { UseDashboard } from "hooks/DashboardHook";
import { useQuery } from "react-query";

interface VersionsCardProps {
  [x: string]: any;
  name: string;
}

export default function TefCard(props: VersionsCardProps) {
  const [filter, setFilter] = useState<number>(6);
  const [versionSelect, setVersionSelect] = useState<string>("");
  const [openModal, setOpenModal] = useState(false);
  const { name, ...rest } = props;
  const theme = useColorMode();
  const themeSelect = theme.colorMode;

  const { findTEFsByDate } = UseDashboard();

  const { data, isLoading, error } = useQuery(["findTEFsByDate", filter], () =>
    findTEFsByDate(filter)
  );

  // Chakra Color Mode
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb="0px"
      {...rest}
    >
      <Flex
        align="center"
        justify="space-between"
        textAlign="center"
        w="100%"
        pe="20px"
        pt="5px"
      >
        <Button
          bg={boxBg}
          fontSize="sm"
          fontWeight="500"
          color={textColorSecondary}
          borderRadius="7px"
        >
          {name}
        </Button>

        <Menu onFilterSelected={(data: any) => setFilter(data)} />
      </Flex>
      <Flex h={"100%"} w="100%" flexDirection={{ base: "column", lg: "column" }}>
        <Box minH="100%" minW="100%" mt="auto">
          {isLoading ? (
            <Flex alignItems={"center"} justify={"center"} w="full" h={"full"}>
              <Spinner w={32} h={32} />
            </Flex>
          ) : error ? (
            <Flex
              width={"100%"}
              height={"100%"}
              justify={"center"}
              align={"center"}
            >
              <Text align="center">{String(error || "")}</Text>
            </Flex>
          ) : data && Array.isArray(data) && data.length > 0 ? (
            <PieChart
              key={themeSelect + filter + data}
              chartData={data.map((item) => item.QUANTIDADE)}
              chartOptions={{
                labels: data.map((item) => item.TEF),
                theme: {
                  mode: themeSelect,
                },
                chart: {
                  width: "50px",
                  background: "transparent",
                  events: {
                    legendClick: function (
                      event: any,
                      index: any,
                      config: any
                    ) {
                      setVersionSelect(data[index].TEF);
                      setOpenModal(true);
                    },
                  },
                },
                ...pieChartOptions,
              }}
            />
          ) : (
            <Flex
              width={"100%"}
              height={"100%"}
              justify={"center"}
              align={"center"}
            >
              <Text fontWeight={"bold"} fontSize={"xl"} align="center">
                Nenhum dado disponível
              </Text>
            </Flex>
          )}
        </Box>
        {openModal ? (
          <TefsModal
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            dias={filter}
            tef={versionSelect}
          />
        ) : null}
      </Flex>
    </Card>
  );
}
